import { Panel, Typography } from "@/components/atoms";
import { PageList } from "@/components/molecules";
import { usePermissions } from "@/permissions";
import { EPermission } from "@/permissions/types";
import { DispatchSettings } from "./DispatchSettings/DispatchSettings";

type Subpage = {
  name: string;
  desc: string;
  to: string;
  icon: string;
  permission?: EPermission | EPermission[];
};

const subpages: Subpage[] = [
  {
    name: "Dispatch Settings",
    desc: "Configuration settings to determine when to dispatch jobs.",
    to: "dispatch-settings",
    icon: "Export",
    permission: [EPermission.ProviderConfigProfileAdvancedManage, EPermission.ProviderConfigDispatchManage],
  },
];

export const DispatchPanel = () => {
  const { hasPermission, hasAllPermissions } = usePermissions();

  const visibleSubpages = subpages.filter(({ permission }) => {
    if (!permission) return true;
    return Array.isArray(permission) ? hasAllPermissions(permission) : hasPermission(permission);
  });

  return (
    <Panel>
      <Typography variant="h3">Dispatch Settings</Typography>
      <PageList className="-mx-5 mt-2">
        {visibleSubpages.map(({ name, desc, to, icon }) => (
          <PageList.Item key={name} title={name} description={desc} to={to} icon={icon} />
        ))}
      </PageList>
    </Panel>
  );
};

DispatchPanel.DispatchSettings = DispatchSettings;
